var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-confirm-dialog',{attrs:{"item":_vm.item,"title":"Kullanıcıyı sil","description":"{name} kullanıcısını silmek istediğinize emin misiniz?","confirm-text":"Kullanıcıyı Sil","save":_vm.save,"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }